// extracted by mini-css-extract-plugin
module.exports = {"main":"NewsPage_main__N_fMq","title":"NewsPage_title__hpvXv","list":"NewsPage_list__aoIYP"};